import { post } from '../api';
import loginService from '../login.service';

const truncate = (value, max) => {
    if (value === null || value === undefined) return '';
    const asString = typeof value === 'string' ? value : String(value);
    return asString.length > max ? asString.slice(0, max) : asString;
};

const serializeError = (error) => {
    if (!error) return { message: '' };
    if (error instanceof Error) {
        return {
            name: error.name,
            message: truncate(error.message, 500),
            stack: truncate(error.stack, 2000)
        };
    }
    if (typeof error === 'object') {
        return {
            message: truncate(error.message || JSON.stringify(error), 500),
            status: error.status,
            code: error.code
        };
    }
    return { message: truncate(String(error), 500) };
};

const THROTTLE_WINDOW_MS = 10000;
const MAX_EVENTS_PER_SESSION = 20;

const lastSentBySignature = new Map();
let sentEventsCount = 0;

const buildSignature = (context, message, error) => {
    const stackLines = String((error && error.stack) || '').split('\n');
    const originLine = (stackLines[1] || '').trim();
    return [context, message, originLine].join('|');
};

const shouldSend = (signature) => {
    if (sentEventsCount >= MAX_EVENTS_PER_SESSION) return false;

    const now = Date.now();
    const lastSentAt = lastSentBySignature.get(signature);

    if (lastSentAt !== undefined && (now - lastSentAt) < THROTTLE_WINDOW_MS) return false;

    lastSentBySignature.set(signature, now);
    sentEventsCount += 1;
    return true;
};

const logClientError = async ({ context, message, payload = {}, error }) => {
    if (!shouldSend(buildSignature(context, message, error))) return;

    const user = loginService.getUserAuthentication?.() || {};
    const enrichedPayload = {
        ...payload,
        userId: user?.id,
        userSource: user?.source,
        customerId: user?.customer?.id,
        path: typeof window !== 'undefined' ? window.location?.pathname : null,
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
        error: serializeError(error)
    };
    try {
        await post({
            type: 'user',
            service: 'client-error-log',
            data: {
                context: truncate(context, 100),
                message: truncate(message, 500),
                payload: enrichedPayload
            }
        });
    } catch (_) {
        // intencionalmente silencioso: se o logging falha, não temos onde reportar
        // sem criar loop. O console serve de último recurso no dev.
        if (process.env.NODE_ENV !== 'production')
            console.warn('[clientLogger] falha ao enviar erro:', context, error);
    }
};

export default { logClientError };
